import { render, staticRenderFns } from "./StockLevelNotificationModal.vue?vue&type=template&id=cf5022a2&"
import script from "./StockLevelNotificationModal.vue?vue&type=script&lang=js&"
export * from "./StockLevelNotificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports